import { createFileRoute } from "@tanstack/react-router";

import { AlphaRunPage } from "@/features/request/alpha";
import { requireAlphaFeatureFlag } from "@/lib/posthog-flags";

export const Route = createFileRoute(
  "/_auth/_app-shell/requests/$requestId/alpha",
)({
  beforeLoad: requireAlphaFeatureFlag,
  component: AlphaRunPage,
  params: {
    parse: (rawParams) => ({ requestId: Number(rawParams["requestId"]) }),
  },
});
